import { ECalculateResultModalActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const openCalculateResultModal = actionGenerator<ECalculateResultModalActionType.ModalOpened>(
  ECalculateResultModalActionType.ModalOpened,
);
